export default __webpack_public_path__ + "static/media/a011-fsi-08.84d26346.svg";